export const iconPaths = {
  Clear: (
    <>
      <path d="M21 3L13 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.44573 11.0854C6.96539 12.0368 4.98269 11.8736 3 11.0885C3.50059 17.531 6.50414 20.0089 10.5089 21C10.5089 21 13.5261 18.8664 13.961 13.8074C14.0081 13.2595 14.0317 12.9856 13.9178 12.6769C13.8038 12.3682 13.5802 12.1468 13.1329 11.704C12.3973 10.9757 12.0295 10.6116 11.5929 10.5204C11.1564 10.4293 10.5862 10.648 9.44573 11.0854Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.5 16.4464C4.5 16.4464 7 16.9286 9.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.5 7.25C8.5 7.94036 7.94036 8.5 7.25 8.5C6.55964 8.5 6 7.94036 6 7.25C6 6.55964 6.55964 6 7.25 6C7.94036 6 8.5 6.55964 8.5 7.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M11 4V4.1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Fullscreen: (
    <>
      <path
        d="M7.93668 16.0634C7.41936 15.5461 7.50535 13.3483 7.50535 13.3483M7.93668 16.0634C8.45401 16.5808 10.6517 16.4946 10.6517 16.4946M7.93668 16.0634L11 13M16.0634 7.93661C15.5461 7.41928 13.3484 7.50537 13.3484 7.50537M16.0634 7.93661C16.5808 8.45394 16.4946 10.6516 16.4946 10.6516M16.0634 7.93661L13 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Filter: (
    <>
      <path d="M3 7H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 17H9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 17L21 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 7L21 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6 7C6 6.06812 6 5.60218 6.15224 5.23463C6.35523 4.74458 6.74458 4.35523 7.23463 4.15224C7.60218 4 8.06812 4 9 4C9.93188 4 10.3978 4 10.7654 4.15224C11.2554 4.35523 11.6448 4.74458 11.8478 5.23463C12 5.60218 12 6.06812 12 7C12 7.93188 12 8.39782 11.8478 8.76537C11.6448 9.25542 11.2554 9.64477 10.7654 9.84776C10.3978 10 9.93188 10 9 10C8.06812 10 7.60218 10 7.23463 9.84776C6.74458 9.64477 6.35523 9.25542 6.15224 8.76537C6 8.39782 6 7.93188 6 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12 17C12 16.0681 12 15.6022 12.1522 15.2346C12.3552 14.7446 12.7446 14.3552 13.2346 14.1522C13.6022 14 14.0681 14 15 14C15.9319 14 16.3978 14 16.7654 14.1522C17.2554 14.3552 17.6448 14.7446 17.8478 15.2346C18 15.6022 18 16.0681 18 17C18 17.9319 18 18.3978 17.8478 18.7654C17.6448 19.2554 17.2554 19.6448 16.7654 19.8478C16.3978 20 15.9319 20 15 20C14.0681 20 13.6022 20 13.2346 19.8478C12.7446 19.6448 12.3552 19.2554 12.1522 18.7654C12 18.3978 12 17.9319 12 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  Settings: (
    <>
      <path
        d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M21.011 14.0965C21.5329 13.9558 21.7939 13.8854 21.8969 13.7508C22 13.6163 22 13.3998 22 12.9669V11.0332C22 10.6003 22 10.3838 21.8969 10.2493C21.7938 10.1147 21.5329 10.0443 21.011 9.90358C19.0606 9.37759 17.8399 7.33851 18.3433 5.40087C18.4817 4.86799 18.5509 4.60156 18.4848 4.44529C18.4187 4.28902 18.2291 4.18134 17.8497 3.96596L16.125 2.98673C15.7528 2.77539 15.5667 2.66972 15.3997 2.69222C15.2326 2.71472 15.0442 2.90273 14.6672 3.27873C13.208 4.73448 10.7936 4.73442 9.33434 3.27864C8.95743 2.90263 8.76898 2.71463 8.60193 2.69212C8.43489 2.66962 8.24877 2.77529 7.87653 2.98663L6.15184 3.96587C5.77253 4.18123 5.58287 4.28891 5.51678 4.44515C5.45068 4.6014 5.51987 4.86787 5.65825 5.4008C6.16137 7.3385 4.93972 9.37763 2.98902 9.9036C2.46712 10.0443 2.20617 10.1147 2.10308 10.2492C2 10.3838 2 10.6003 2 11.0332V12.9669C2 13.3998 2 13.6163 2.10308 13.7508C2.20615 13.8854 2.46711 13.9558 2.98902 14.0965C4.9394 14.6225 6.16008 16.6616 5.65672 18.5992C5.51829 19.1321 5.44907 19.3985 5.51516 19.5548C5.58126 19.7111 5.77092 19.8188 6.15025 20.0341L7.87495 21.0134C8.24721 21.2247 8.43334 21.3304 8.6004 21.3079C8.76746 21.2854 8.95588 21.0973 9.33271 20.7213C10.7927 19.2644 13.2088 19.2643 14.6689 20.7212C15.0457 21.0973 15.2341 21.2853 15.4012 21.3078C15.5682 21.3303 15.7544 21.2246 16.1266 21.0133L17.8513 20.034C18.2307 19.8187 18.4204 19.711 18.4864 19.5547C18.5525 19.3984 18.4833 19.132 18.3448 18.5991C17.8412 16.6616 19.0609 14.6226 21.011 14.0965Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  Users: (
    <>
      <path
        d="M18.6161 20H19.1063C20.2561 20 21.1707 19.4761 21.9919 18.7436C24.078 16.8826 19.1741 15 17.5 15M15.5 5.06877C15.7271 5.02373 15.9629 5 16.2048 5C18.0247 5 19.5 6.34315 19.5 8C19.5 9.65685 18.0247 11 16.2048 11C15.9629 11 15.7271 10.9763 15.5 10.9312"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.48131 16.1112C3.30234 16.743 0.211137 18.0331 2.09388 19.6474C3.01359 20.436 4.03791 21 5.32572 21H12.6743C13.9621 21 14.9864 20.436 15.9061 19.6474C17.7889 18.0331 14.6977 16.743 13.5187 16.1112C10.754 14.6296 7.24599 14.6296 4.48131 16.1112Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M13 7.5C13 9.70914 11.2091 11.5 9 11.5C6.79086 11.5 5 9.70914 5 7.5C5 5.29086 6.79086 3.5 9 3.5C11.2091 3.5 13 5.29086 13 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  User: (
    <>
      <path
        d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  Password: (
    <>
      <path d="M8.5 11L9.5 12M9.5 12L10.5 13M9.5 12L10.5 11M9.5 12L8.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3.5 11L4.5 12M4.5 12L5.5 13M4.5 12L5.5 11M4.5 12L3.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M13.5 11L14.5 12M14.5 12L15.5 13M14.5 12L15.5 11M14.5 12L13.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M18.5 11L19.5 12M19.5 12L20.5 13M19.5 12L20.5 11M19.5 12L18.5 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M19.6338 16C17.951 18.8033 15.1069 20.6217 13.406 21.5194C12.7989 21.8398 12.4954 22 12 22C11.5046 22 11.2011 21.8398 10.594 21.5194C8.89306 20.6217 6.04902 18.8033 4.36621 16M20.9999 8C20.9986 6.54505 20.9763 5.7889 20.5959 5.28529C20.1918 4.75029 19.2781 4.49056 17.4507 3.9711C16.2022 3.6162 15.1016 3.18863 14.2223 2.79829C13.0234 2.2661 12.424 2 12 2C11.576 2 10.9766 2.2661 9.77771 2.79829C8.89839 3.18863 7.79784 3.61619 6.54933 3.9711C4.72193 4.49056 3.80822 4.75029 3.40411 5.28529C3.02371 5.7889 3.00139 6.54505 3.00008 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  Logout: (
    <>
      <path
        d="M14 3.09502C13.543 3.03241 13.0755 3 12.6 3C7.29807 3 3 7.02944 3 12C3 16.9706 7.29807 21 12.6 21C13.0755 21 13.543 20.9676 14 20.905"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21 12L11 12M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Chat: (
    <>
      <path d="M8 13.5H16M8 8.5H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  Time: (
    <>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9.5 9.5L12.9999 12.9996M16 8L11 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Timer: (
    <>
      <path
        d="M11.0809 13.152L8 7L13.4196 11.2796C14.1901 11.888 14.1941 13.0472 13.4277 13.6607C12.6614 14.2743 11.5189 14.0266 11.0809 13.152Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 4.82C3.14864 6.63902 2 9.17385 2 11.9776C2 17.5129 6.47715 22.0001 12 22.0001C17.5228 22.0001 22 17.5129 22 11.9776C22 7.1242 18.5581 3.07656 13.9872 2.15288C13.1512 1.98394 12.7332 1.89947 12.3666 2.20022C12 2.50097 12 2.98714 12 3.95949V4.96175"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Send: (
    <>
      <path
        d="M21.0477 3.05293C18.8697 0.707363 2.48648 6.4532 2.50001 8.551C2.51535 10.9299 8.89809 11.6617 10.6672 12.1581C11.7311 12.4565 12.016 12.7625 12.2613 13.8781C13.3723 18.9305 13.9301 21.4435 15.2014 21.4996C17.2278 21.5892 23.1733 5.342 21.0477 3.05293Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M11.5 12.5L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Warning: (
    <>
      <path
        d="M5.32171 9.68293C7.73539 5.41199 8.94222 3.27651 10.5983 2.72681C11.5093 2.4244 12.4907 2.4244 13.4017 2.72681C15.0578 3.27651 16.2646 5.41199 18.6783 9.68293C21.092 13.9538 22.2988 16.0893 21.9368 17.8293C21.7376 18.7866 21.2469 19.6548 20.535 20.3097C19.241 21.5 16.8274 21.5 12 21.5C7.17265 21.5 4.75897 21.5 3.46496 20.3097C2.75308 19.6548 2.26239 18.7866 2.06322 17.8293C1.70119 16.0893 2.90803 13.9538 5.32171 9.68293Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M11.9919 16H12.0009" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 13V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Info: (
    <>
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.9919 8H12.0009" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Tick: (
    <>
      <path d="M5 14L8.5 17.5L19 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Check: (
    <>
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M8 12.5L10.5 15L16 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Close: (
    <>
      <path d="M19.0005 5L5.00049 19M5.00049 5L19.0005 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Eye: (
    <>
      <path
        d="M21.544 11.045C21.848 11.4713 22 11.6845 22 12C22 12.3155 21.848 12.5287 21.544 12.955C20.1779 14.8706 16.6892 19 12 19C7.31078 19 3.8221 14.8706 2.45604 12.955C2.15201 12.5287 2 12.3155 2 12C2 11.6845 2.15201 11.4713 2.45604 11.045C3.8221 9.12944 7.31078 5 12 5C16.6892 5 20.1779 9.12944 21.544 11.045Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  EyeOff: (
    <>
      <path
        d="M19.439 15.439C20.3636 14.5212 21.0775 13.6091 21.544 12.955C21.848 12.5287 22 12.3155 22 12C22 11.6845 21.848 11.4713 21.544 11.045C20.1779 9.12944 16.6892 5 12 5C11.0922 5 10.2294 5.15476 9.41827 5.41827M6.74742 6.74742C4.73118 8.1072 3.24215 9.94266 2.45604 11.045C2.15201 11.4713 2 11.6845 2 12C2 12.3155 2.15201 12.5287 2.45604 12.955C3.8221 14.8706 7.31078 19 12 19C13.9908 19 15.7651 18.2557 17.2526 17.2526"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.85786 10C9.32783 10.53 9 11.2623 9 12.0711C9 13.6887 10.3113 15 11.9289 15C12.7377 15 13.47 14.6722 14 14.1421"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M3 3L21 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  MenuExpendLeftLine: (
    <>
      <path d="M20 8H11M20 12H4M4 12L7 9M4 12L7 15M20 16H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Sun01: (
    <>
      <path
        d="M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M11.9955 3H12.0045M11.9961 21H12.0051M18.3588 5.63599H18.3678M5.63409 18.364H5.64307M5.63409 5.63647H5.64307M18.3582 18.3645H18.3672M20.991 12.0006H21M3 12.0006H3.00898"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Notification03: (
    <>
      <path
        d="M2.52992 14.394C2.31727 15.7471 3.268 16.6862 4.43205 17.1542C8.89481 18.9486 15.1052 18.9486 19.5679 17.1542C20.732 16.6862 21.6827 15.7471 21.4701 14.394C21.3394 13.5625 20.6932 12.8701 20.2144 12.194C19.5873 11.2975 19.525 10.3197 19.5249 9.27941C19.5249 5.2591 16.1559 2 12 2C7.84413 2 4.47513 5.2591 4.47513 9.27941C4.47503 10.3197 4.41272 11.2975 3.78561 12.194C3.30684 12.8701 2.66061 13.5625 2.52992 14.394Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 21C9.79613 21.6219 10.8475 22 12 22C13.1525 22 14.2039 21.6219 15 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  FilterVertical: (
    <>
      <path d="M7 21L7 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17 21L17 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17 6L17 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 9L7 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7 18C6.06812 18 5.60218 18 5.23463 17.8478C4.74458 17.6448 4.35523 17.2554 4.15224 16.7654C4 16.3978 4 15.9319 4 15C4 14.0681 4 13.6022 4.15224 13.2346C4.35523 12.7446 4.74458 12.3552 5.23463 12.1522C5.60218 12 6.06812 12 7 12C7.93188 12 8.39782 12 8.76537 12.1522C9.25542 12.3552 9.64477 12.7446 9.84776 13.2346C10 13.6022 10 14.0681 10 15C10 15.9319 10 16.3978 9.84776 16.7654C9.64477 17.2554 9.25542 17.6448 8.76537 17.8478C8.39782 18 7.93188 18 7 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M17 12C16.0681 12 15.6022 12 15.2346 11.8478C14.7446 11.6448 14.3552 11.2554 14.1522 10.7654C14 10.3978 14 9.93188 14 9C14 8.06812 14 7.60218 14.1522 7.23463C14.3552 6.74458 14.7446 6.35523 15.2346 6.15224C15.6022 6 16.0681 6 17 6C17.9319 6 18.3978 6 18.7654 6.15224C19.2554 6.35523 19.6448 6.74458 19.8478 7.23463C20 7.60218 20 8.06812 20 9C20 9.93188 20 10.3978 19.8478 10.7654C19.6448 11.2554 19.2554 11.6448 18.7654 11.8478C18.3978 12 17.9319 12 17 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  Point: (
    <>
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </>
  ),
  CheckmarkCircle02: (
    <>
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M8 12.5L10.5 15L16 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  File01: (
    <>
      <path
        d="M3.5 10C3.5 6.22876 3.5 4.34315 4.7448 3.17157C5.98959 2 7.99306 2 12 2H12.7727C16.0339 2 17.6645 2 18.7969 2.79784C19.1214 3.02643 19.4094 3.29752 19.6523 3.60289C20.5 4.66867 20.5 6.20336 20.5 9.27273V11.8182C20.5 14.7814 20.5 16.2629 20.0311 17.4462C19.2772 19.3486 17.6829 20.8491 15.6616 21.5586C14.4044 22 12.8302 22 9.68182 22C7.88275 22 6.98322 22 6.26478 21.7478C5.10979 21.3424 4.19875 20.4849 3.76796 19.3979C3.5 18.7217 3.5 17.8751 3.5 16.1818V10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 12C20.5 13.8409 19.0076 15.3333 17.1667 15.3333C16.5009 15.3333 15.716 15.2167 15.0686 15.3901C14.4935 15.5442 14.0442 15.9935 13.8901 16.5686C13.7167 17.216 13.8333 18.0009 13.8333 18.6667C13.8333 20.5076 12.3409 22 10.5 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 7H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 11H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Arrow: (
    <>
      <path
        d="M8.24374 10.2569C8.03957 10.461 8.03957 10.7902 8.24374 10.9944L11.7062 14.4569C11.8687 14.6194 12.1312 14.6194 12.2937 14.4569L15.7562 10.9944C15.9604 10.7902 15.9604 10.461 15.7562 10.2569C15.5521 10.0527 15.2229 10.0527 15.0187 10.2569L11.9979 13.2735L8.97707 10.2527C8.77707 10.0527 8.44374 10.0527 8.24374 10.2569V10.2569Z"
        fill="currentColor"
      />
    </>
  ),
  Logout01: (
    <>
      <path
        d="M14 3.09502C13.543 3.03241 13.0755 3 12.6 3C7.29807 3 3 7.02944 3 12C3 16.9706 7.29807 21 12.6 21C13.0755 21 13.543 20.9676 14 20.905"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M21 12L11 12M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  ChartRing: (
    <>
      <path d="M9 9L5 5M16 12H22M12 16V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
    </>
  ),
  DarkMode: (
    <>
      <path
        d="M23.0279 15.7767C22.905 15.6686 22.7247 15.6474 22.5778 15.722C18.3731 17.8682 13.2129 16.4407 10.8319 12.4718C8.45101 8.50294 9.74584 3.48909 13.7798 1.05717C13.9208 0.972323 13.9912 0.811064 13.9554 0.654917C13.9198 0.498513 13.7859 0.380444 13.621 0.360255C11.0072 0.0369701 8.41887 0.537103 6.13434 1.80673C3.37101 3.34137 1.39424 5.82083 0.568375 8.78712C-0.25749 11.7534 0.16633 14.8516 1.76203 17.5112C3.35746 20.1708 5.93358 22.0732 9.01584 22.868C10.0451 23.1333 11.0895 23.2646 12.1273 23.2646C14.1973 23.2646 16.2404 22.7423 18.081 21.7195C20.365 20.4504 22.1097 18.5429 23.1257 16.203C23.1899 16.0553 23.1506 15.8848 23.0279 15.7767Z"
        fill="currentColor"
      />
    </>
  ),
  Loader: (
    <>
      <path
        d="M19 4.78497L17.4444 6.45094C14.4444 3.4522 9.44444 3.4522 6.44444 6.45094C3.44444 9.44969 3.44444 14.4476 6.44444 17.4463C9.44444 20.4451 14.4444 20.4451 17.4444 17.4463C18.8889 16.0025 19.7778 14.0033 19.7778 12.0042H22C22 17.5574 17.5556 22 12 22C6.44444 22 2 17.5574 2 12.0042C2 6.45095 6.44444 2.00836 12 2.00836C14.5556 1.89729 17.1111 2.89688 19 4.78497Z"
        fill="currentColor"
      />
    </>
  ),
  Location: (
    <>
      <path
        d="M4 17C2.17107 17.4117 1 18.0443 1 18.7537C1 19.9943 4.58172 21 9 21C13.4183 21 17 19.9943 17 18.7537C17 18.0443 15.8289 17.4117 14 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11.5 8C11.5 9.38071 10.3807 10.5 9 10.5C7.61929 10.5 6.5 9.38071 6.5 8C6.5 6.61929 7.61929 5.5 9 5.5C10.3807 5.5 11.5 6.61929 11.5 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10.2574 16.4936C9.92012 16.8184 9.46932 17 9.00015 17C8.53099 17 8.08018 16.8184 7.7429 16.4936C4.6543 13.5008 0.51519 10.1575 2.53371 5.30373C3.6251 2.67932 6.24494 1 9.00015 1C11.7554 1 14.3752 2.67933 15.4666 5.30373C17.4826 10.1514 13.3536 13.5111 10.2574 16.4936Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  Notice: (
    <>
      <path
        d="M1.5 10.5C1.5 6.02166 1.5 3.78249 2.89124 2.39124C4.28249 1 6.52166 1 11 1C15.4783 1 17.7175 1 19.1088 2.39124C20.5 3.78249 20.5 6.02166 20.5 10.5C20.5 14.9783 20.5 17.2175 19.1088 18.6088C17.7175 20 15.4783 20 11 20C6.52166 20 4.28249 20 2.89124 18.6088C1.5 17.2175 1.5 14.9783 1.5 10.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M10 6L16 6M7 6C7 6.27614 6.77614 6.5 6.5 6.5C6.22386 6.5 6 6.27614 6 6C6 5.72386 6.22386 5.5 6.5 5.5C6.77614 5.5 7 5.72386 7 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.5H16M7 10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5C6 10.2239 6.22386 10 6.5 10C6.77614 10 7 10.2239 7 10.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15H16M7 15C7 15.2761 6.77614 15.5 6.5 15.5C6.22386 15.5 6 15.2761 6 15C6 14.7239 6.22386 14.5 6.5 14.5C6.77614 14.5 7 14.7239 7 15Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Copy: (
    <>
      <path
        d="M1 11.4C1 8.38301 1 6.87452 1.94627 5.93726C2.89254 5 4.41554 5 7.46154 5H8.53846C11.5845 5 13.1075 5 14.0537 5.93726C15 6.87452 15 8.38301 15 11.4V14.6C15 17.617 15 19.1255 14.0537 20.0627C13.1075 21 11.5845 21 8.53846 21H7.46154C4.41554 21 2.89254 21 1.94627 20.0627C1 19.1255 1 17.617 1 14.6V11.4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14.5376 15H15.4608C18.072 15 19.3776 15 20.1888 14.1799C21 13.3598 21 12.0399 21 9.4V6.6C21 3.96013 21 2.6402 20.1888 1.8201C19.3776 1 18.072 1 15.4608 1H14.5376C11.9264 1 10.6208 1 9.80959 1.8201C9.10022 2.53726 9.01118 3.63664 9 5.66667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M5 11H8M5 16H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9.5 2L13.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </>
  ),
  Sun02: (
    <>
      <path
        d="M6.5 12C6.5 8.96243 8.96243 6.5 12 6.5C15.0376 6.5 17.5 8.96243 17.5 12C17.5 15.0376 15.0376 17.5 12 17.5C8.96243 17.5 6.5 15.0376 6.5 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7455 3C10.7455 2.30964 11.3052 1.75 11.9955 1.75H12.0045C12.6948 1.75 13.2545 2.30964 13.2545 3C13.2545 3.69036 12.6948 4.25 12.0045 4.25H11.9955C11.3052 4.25 10.7455 3.69036 10.7455 3ZM17.1088 5.63599C17.1088 4.94563 17.6684 4.38599 18.3588 4.38599H18.3678C19.0581 4.38599 19.6178 4.94563 19.6178 5.63599C19.6178 6.32634 19.0581 6.88599 18.3678 6.88599H18.3588C17.6684 6.88599 17.1088 6.32634 17.1088 5.63599ZM4.38409 5.63647C4.38409 4.94612 4.94373 4.38647 5.63409 4.38647H5.64307C6.33342 4.38647 6.89307 4.94612 6.89307 5.63647C6.89307 6.32683 6.33342 6.88647 5.64307 6.88647H5.63409C4.94373 6.88647 4.38409 6.32683 4.38409 5.63647ZM1.75 12.0006C1.75 11.3102 2.30964 10.7506 3 10.7506H3.00898C3.69933 10.7506 4.25898 11.3102 4.25898 12.0006C4.25898 12.6909 3.69933 13.2506 3.00898 13.2506H3C2.30964 13.2506 1.75 12.6909 1.75 12.0006ZM19.741 12.0006C19.741 11.3102 20.3007 10.7506 20.991 10.7506H21C21.6904 10.7506 22.25 11.3102 22.25 12.0006C22.25 12.6909 21.6904 13.2506 21 13.2506H20.991C20.3007 13.2506 19.741 12.6909 19.741 12.0006ZM4.38409 18.364C4.38409 17.6737 4.94373 17.114 5.63409 17.114H5.64307C6.33342 17.114 6.89307 17.6737 6.89307 18.364C6.89307 19.0544 6.33342 19.614 5.64307 19.614H5.63409C4.94373 19.614 4.38409 19.0544 4.38409 18.364ZM17.1082 18.3645C17.1082 17.6741 17.6679 17.1145 18.3582 17.1145H18.3672C19.0575 17.1145 19.6172 17.6741 19.6172 18.3645C19.6172 19.0549 19.0575 19.6145 18.3672 19.6145H18.3582C17.6679 19.6145 17.1082 19.0549 17.1082 18.3645ZM10.7461 21C10.7461 20.3096 11.3057 19.75 11.9961 19.75H12.0051C12.6954 19.75 13.2551 20.3096 13.2551 21C13.2551 21.6904 12.6954 22.25 12.0051 22.25H11.9961C11.3057 22.25 10.7461 21.6904 10.7461 21Z"
        fill="currentColor"
      />
    </>
  ),
  SelectArrow: (
    <>
      <path
        d="M21.0847 9.32833L12.6003 17.1052C12.5216 17.1776 12.428 17.2349 12.325 17.274C12.222 17.3132 12.1116 17.3333 12.0001 17.3333C11.8886 17.3333 11.7782 17.3132 11.6752 17.274C11.5722 17.2349 11.4786 17.1776 11.3998 17.1052L2.91539 9.32833C2.75619 9.18241 2.66675 8.98449 2.66675 8.77812C2.66675 8.57175 2.75619 8.37383 2.91539 8.22791C3.07459 8.08199 3.29052 8 3.51567 8C3.7408 8 3.95673 8.08199 4.11593 8.22791L12.0001 15.4556L19.8842 8.22791C19.963 8.15565 20.0566 8.09833 20.1597 8.05923C20.2626 8.02012 20.373 8 20.4845 8C20.5959 8 20.7063 8.02012 20.8094 8.05923C20.9123 8.09833 21.0059 8.15565 21.0847 8.22791C21.1635 8.30016 21.2261 8.38595 21.2687 8.48035C21.3114 8.57476 21.3334 8.67593 21.3334 8.77812C21.3334 8.88031 21.3114 8.98149 21.2687 9.07589C21.2261 9.17031 21.1635 9.25608 21.0847 9.32833Z"
        fill="currentColor"
      />
    </>
  ),
  Toggle: (
    <>
      <path d="M20 5H4M20 19H4M4 12H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Clock02: (
    <>
      <path
        d="M5.048 8.60702L2.538 8.45402C4.338 3.70402 9.503 1.00002 14.54 2.34402C19.904 3.77702 23.09 9.26102 21.657 14.594C20.223 19.926 14.712 23.088 9.347 21.655C7.46089 21.1545 5.76152 20.1152 4.4567 18.6642C3.15188 17.2133 2.29818 15.4135 2 13.485"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 8V12L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Calendar03: (
    <>
      <path d="M18 2V4M6 2V4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.9955 13H12.0045M11.9955 17H12.0045M15.991 13H16M8 13H8.00897M8 17H8.00897"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.5 8H20.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 8H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  AddCircle: (
    <>
      <path d="M12 8V16M16 12L8 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  CancelCircle: (
    <>
      <path d="M14.9994 15L9 9M9.00064 15L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  Edit02: (
    <>
      <path
        d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M13 4L20 11" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </>
  ),
  Energy: (
    <>
      <path
        d="M19.3352 6.79085C16.9084 3.33525 12.4029 2.03556 8.50846 3.66769C4.61401 5.29982 2.38138 9.42339 3.14342 13.5767"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.4209 19.2101V17.2092H6.42173" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M4.66504 17.2092C7.09183 20.6648 11.5973 21.9645 15.4917 20.3323C19.3862 18.7002 21.6188 14.5766 20.8568 10.4233"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M19.5792 4.79004V6.79087H17.5784" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.3302 15.3315L14.0009 12.0001H9.99927L11.67 8.6687"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Delete02: (
    <>
      <path
        d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.0557 5.5H8.05292L8.65861 4.17126L8.65861 4.17125C9.10063 3.20155 9.32164 2.7167 9.71729 2.41317C9.80498 2.3459 9.8981 2.28601 9.99568 2.23412C10.436 2 10.9688 2 12.0345 2C13.0741 2 13.5939 2 14.027 2.2247C14.1231 2.27454 14.215 2.3321 14.3017 2.39681C14.6928 2.68852 14.9196 3.15626 15.3731 4.09173L16.0557 5.5Z"
        fill="currentColor"
      />
      <path
        d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M9.5 16.5L9.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14.5 16.5L14.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  Store01: (
    <>
      <path
        d="M2 10L2 14.5C2 17.3284 2 18.7426 2.87868 19.6213C3.75736 20.5 5.17157 20.5 8 20.5H14C16.8284 20.5 18.2426 20.5 19.1213 19.6213C20 18.7426 20 17.3284 20 14.5V10"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6.97071 8L7.6952 7.80605C7.59787 7.44245 7.2461 7.20732 6.87291 7.2564C6.49971 7.30549 6.22071 7.62359 6.22071 8H6.97071ZM1.11347 9.04045L1.8163 8.77865L1.8163 8.77865L1.11347 9.04045ZM20.8865 9.04045L20.1837 8.77865L20.1837 8.77866L20.8865 9.04045ZM15.0293 8H15.7793C15.7793 7.62359 15.5003 7.30549 15.1271 7.2564C14.7539 7.20732 14.4021 7.44245 14.3048 7.80605L15.0293 8ZM1.45767 7.0777L2.10768 7.45185L2.10768 7.45185L1.45767 7.0777ZM2.42134 5.40355L1.77133 5.02939H1.77133L2.42134 5.40355ZM20.5423 7.0777L19.8923 7.45185V7.45185L20.5423 7.0777ZM19.5787 5.40355L20.2287 5.02939V5.02939L19.5787 5.40355ZM20.9873 8.22893L20.2398 8.29116V8.29117L20.9873 8.22893ZM1.01274 8.22893L0.265329 8.16669L1.01274 8.22893ZM6.22071 8C6.22071 9.23749 5.20869 10.25 3.94875 10.25V11.75C6.02678 11.75 7.72071 10.0762 7.72071 8H6.22071ZM3.94875 10.25C2.96882 10.25 2.13568 9.63607 1.8163 8.77865L0.41065 9.30225C0.943544 10.7329 2.32767 11.75 3.94875 11.75V10.25ZM20.1837 8.77866C19.8643 9.63607 19.0312 10.25 18.0513 10.25V11.75C19.6723 11.75 21.0565 10.7329 21.5894 9.30225L20.1837 8.77866ZM18.0513 10.25C16.7913 10.25 15.7793 9.23749 15.7793 8H14.2793C14.2793 10.0762 15.9732 11.75 18.0513 11.75V10.25ZM11 10.25C9.39133 10.25 8.06678 9.1941 7.6952 7.80605L6.24623 8.19395C6.79833 10.2564 8.73155 11.75 11 11.75V10.25ZM14.3048 7.80605C13.9332 9.1941 12.6087 10.25 11 10.25V11.75C13.2685 11.75 15.2017 10.2564 15.7538 8.19395L14.3048 7.80605ZM2.10768 7.45185L3.07134 5.7777L1.77133 5.02939L0.807664 6.70355L2.10768 7.45185ZM21.1923 6.70355L20.2287 5.02939L18.9287 5.7777L19.8923 7.45185L21.1923 6.70355ZM4.91511 2.25H17.0849V0.75H4.91511V2.25ZM19.8086 3.45934C19.8086 1.95786 18.584 0.75 17.0849 0.75V2.25C17.7659 2.25 18.3086 2.79659 18.3086 3.45934H19.8086ZM20.2287 5.02939C19.9532 4.55089 19.8086 4.00972 19.8086 3.45934H18.3086C18.3086 4.27286 18.5224 5.072 18.9287 5.7777L20.2287 5.02939ZM3.69143 3.45934C3.69143 2.79659 4.23412 2.25 4.91511 2.25V0.75C3.41603 0.75 2.19143 1.95786 2.19143 3.45934H3.69143ZM21.5893 9.30225C21.6322 9.18715 21.6943 9.02692 21.726 8.82441C21.7576 8.62312 21.7553 8.41456 21.7347 8.16669L20.2398 8.29117C20.256 8.48553 20.2492 8.55963 20.2442 8.592C20.2393 8.62315 20.2325 8.64756 20.1837 8.77865L21.5893 9.30225ZM19.8923 7.45185C20.1674 7.92967 20.2185 8.03434 20.2398 8.29116L21.7347 8.16669C21.6824 7.53904 21.4614 7.17106 21.1923 6.70355L19.8923 7.45185ZM3.07134 5.7777C3.47755 5.072 3.69143 4.27286 3.69143 3.45934H2.19143C2.19143 4.00972 2.04676 4.55089 1.77133 5.02939L3.07134 5.7777ZM1.8163 8.77865C1.76747 8.64756 1.76074 8.62315 1.75585 8.592C1.75078 8.55963 1.74397 8.48552 1.76016 8.29116L0.265329 8.16669C0.244688 8.41457 0.242397 8.62312 0.273967 8.82441C0.305728 9.02692 0.367777 9.18715 0.41065 9.30225L1.8163 8.77865ZM0.807664 6.70355C0.53856 7.17106 0.317593 7.53904 0.265329 8.16669L1.76016 8.29116C1.78154 8.03434 1.83264 7.92967 2.10768 7.45185L0.807664 6.70355Z"
        fill="currentColor"
      />
      <path d="M6 17H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  Calendar02: (
    <>
      <path d="M11 13L16 13M8 13H8.00898M13 17H8M16 17H15.991" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 2V4M6 2L6 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3L12.95 3C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 8L21 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Building02: (
    <>
      <path d="M15 2H9C5.69067 2 5 2.69067 5 6V22H19V6C19 2.69067 18.3093 2 15 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M3 22H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15 22V19C15 17.3453 14.6547 17 13 17H11C9.34533 17 9 17.3453 9 19V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M13.5 6H10.5M13.5 9.5H10.5M13.5 13H10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  Building06: (
    <>
      <path
        d="M12 2.00039H6C3.518 2.00039 3 2.51839 3 5.00039V22.0004H15V5.00039C15 2.51839 14.482 2.00039 12 2.00039Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M18 8.00039H15V22.0004H21V11.0004C21 8.51839 20.482 8.00039 18 8.00039Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M8.0004 6H10.0004M8.0004 9H10.0004M8.0004 12H10.0004"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5004 21.9996V17.9996C11.5004 17.0568 11.5004 16.5854 11.2075 16.2925C10.9146 15.9996 10.4432 15.9996 9.5004 15.9996H8.5004C7.55759 15.9996 7.08619 15.9996 6.79329 16.2925C6.5004 16.5854 6.5004 17.0568 6.5004 17.9996V21.9996"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </>
  ),
  UserMultiple: (
    <>
      <path
        d="M15.5134 14.6665H15.9219C16.8801 14.6665 17.6423 14.2299 18.3266 13.6195C20.065 12.0687 15.9784 10.4998 14.5833 10.4998M12.9167 2.22381C13.1059 2.18628 13.3024 2.1665 13.504 2.1665C15.0206 2.1665 16.25 3.28579 16.25 4.6665C16.25 6.04722 15.0206 7.1665 13.504 7.1665C13.3024 7.1665 13.1059 7.14673 12.9167 7.1092"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3.73443 11.4258C2.75195 11.9523 0.175948 13.0274 1.7449 14.3727C2.51133 15.0298 3.36492 15.4998 4.4381 15.4998H10.5619C11.6351 15.4998 12.4887 15.0298 13.2551 14.3727C14.8241 13.0274 12.2481 11.9523 11.2656 11.4258C8.96167 10.1912 6.03832 10.1912 3.73443 11.4258Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10.8333 4.24984C10.8333 6.09079 9.34095 7.58317 7.5 7.58317C5.65905 7.58317 4.16667 6.09079 4.16667 4.24984C4.16667 2.40889 5.65905 0.916504 7.5 0.916504C9.34095 0.916504 10.8333 2.40889 10.8333 4.24984Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  LeftToRigthListDash: (
    <>
      <path d="M9 5H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3 5H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9 12H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3 12H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M9 19H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M3 19H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  ArrowDown: (
    <>
      <path
        d="M10.25 5.24996C10.25 5.24996 6.9358 0.75001 5.74996 0.75C4.56413 0.74999 1.25 5.25 1.25 5.25"
        stroke="#101A23"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  ArrowMoveDown: (
    <>
      <path
        d="M1.58301 0.75V1.96154C1.58301 3.12875 1.58301 3.71236 1.66778 4.20068C2.13443 6.88872 4.44517 8.99691 7.39147 9.42266C7.9267 9.5 9.05365 9.5 10.333 9.5"
        stroke="#101A23"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16602 11.25C9.52001 10.9059 10.916 9.99016 10.916 9.5C10.916 9.00984 9.52 8.09407 9.16602 7.75"
        stroke="#101A23"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Building1: (
    <>
      <path d="M13 7H9C6.518 7 6 7.518 6 10V21H16V10C16 7.518 15.482 7 13 7Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10 11L12 11M10 14H12M10 17H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M20 21V7.18564C20 5.95735 20 5.3432 19.7013 4.84966C19.4026 4.35612 18.8647 4.08147 17.7889 3.53216L13.4472 1.31536C12.2868 0.722844 12 0.931662 12 2.22873V6.7035"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 21V12C2 11.1727 2.17267 11 3 11H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 21H1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Passport: (
    <>
      <path
        d="M1.91699 10.5C1.91699 6.96447 1.91699 5.1967 3.13738 4.09835C4.35777 3 6.32196 3 10.2503 3C14.1787 3 16.1429 3 17.3632 4.09835C18.5837 5.1967 18.5837 6.96447 18.5837 10.5C18.5837 14.0355 18.5837 15.8033 17.3632 16.9017C16.1429 18 14.1787 18 10.2503 18C6.32196 18 4.35777 18 3.13738 16.9017C1.91699 15.8033 1.91699 14.0355 1.91699 10.5Z"
        stroke="#2A3845"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.41699 14.25C5.42392 12.0991 9.17716 11.9576 10.2503 14.25M9.00033 8.41667C9.00033 9.33717 8.25413 10.0833 7.33366 10.0833C6.41318 10.0833 5.66699 9.33717 5.66699 8.41667C5.66699 7.49619 6.41318 6.75 7.33366 6.75C8.25413 6.75 9.00033 7.49619 9.00033 8.41667Z"
        stroke="#2A3845"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path d="M12.75 8.83325H16.0833" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.75 12.1667H16.0833" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  MapLocation1: (
    <>
      <path
        d="M13.1076 11.9557C12.9671 12.091 12.7792 12.1667 12.5837 12.1667C12.3882 12.1667 12.2004 12.091 12.0599 11.9557C10.773 10.7087 9.0483 9.31567 9.88938 7.29322C10.3441 6.19972 11.4357 5.5 12.5837 5.5C13.7317 5.5 14.8233 6.19972 15.278 7.29322C16.118 9.31308 14.3976 10.7129 13.1076 11.9557Z"
        stroke="#2A3845"
        strokeWidth="1.25"
      />
      <path d="M12.583 8.41675H12.5905" stroke="#2A3845" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.58301 10.4999C2.58301 6.76797 2.58301 4.90199 3.74237 3.74262C4.90175 2.58325 6.76772 2.58325 10.4997 2.58325C14.2316 2.58325 16.0976 2.58325 17.257 3.74262C18.4163 4.90199 18.4163 6.76797 18.4163 10.4999C18.4163 14.2318 18.4163 16.0978 17.257 17.2573C16.0976 18.4166 14.2316 18.4166 10.4997 18.4166C6.76772 18.4166 4.90175 18.4166 3.74237 17.2573C2.58301 16.0978 2.58301 14.2318 2.58301 10.4999Z"
        stroke="#2A3845"
        strokeWidth="1.25"
      />
      <path d="M14.6667 17.9999L3 6.33325" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.83301 12.1667L3.83301 17.1667" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  MapLocation2: (
    <>
      <path
        d="M19.0837 8.83341V8.18132C19.0837 6.56497 19.0837 5.75681 18.5955 5.25466C18.1073 4.75253 17.3217 4.75253 15.7503 4.75253H14.0182C13.2537 4.75253 13.2473 4.75105 12.5599 4.40703L9.78358 3.0177C8.62436 2.43761 8.04476 2.14757 7.42731 2.16773C6.80985 2.18789 6.2493 2.51515 5.1282 3.16967L4.10498 3.76706C3.28148 4.24782 2.86973 4.48821 2.64336 4.88811C2.41699 5.28802 2.41699 5.77502 2.41699 6.74902V13.5965C2.41699 14.8762 2.41699 15.5162 2.70221 15.8723C2.892 16.1092 3.15796 16.2686 3.45199 16.3214C3.89388 16.4007 4.43489 16.0849 5.51688 15.4532C6.25163 15.0242 6.95875 14.5787 7.83772 14.6996C8.57423 14.8007 9.25866 15.2655 9.91699 15.5949"
        stroke="#2A3845"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.41699 2.16675V14.6667" stroke="#2A3845" strokeWidth="1.25" strokeLinejoin="round" />
      <path d="M13.25 4.66675V8.41675" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16.0066 18.5696C15.8259 18.7388 15.5844 18.8333 15.3331 18.8333C15.0818 18.8333 14.8403 18.7388 14.6596 18.5696C13.0049 17.0108 10.7876 15.2696 11.8689 12.7415C12.4536 11.3747 13.8571 10.5 15.3331 10.5C16.8091 10.5 18.2126 11.3747 18.7973 12.7415C19.8773 15.2663 17.6653 17.0162 16.0066 18.5696Z"
        stroke="#2A3845"
        strokeWidth="1.25"
      />
      <path d="M15.333 14.25H15.3405" stroke="#2A3845" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  UserGroup: (
    <>
      <path
        d="M20.774 18C21.5233 18 22.1193 17.5285 22.6544 16.8691C23.7499 15.5194 21.9513 14.4408 21.2653 13.9126C20.568 13.3756 19.7894 13.0714 19 13M18 11C19.3807 11 20.5 9.88071 20.5 8.5C20.5 7.11929 19.3807 6 18 6"
        stroke="#1D5EA0"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3.22596 18C2.47665 18 1.88067 17.5285 1.34554 16.8691C0.250091 15.5194 2.04867 14.4408 2.73464 13.9126C3.43197 13.3756 4.21058 13.0714 5 13M5.5 11C4.11929 11 3 9.88071 3 8.5C3 7.11929 4.11929 6 5.5 6"
        stroke="#1D5EA0"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.0838 15.1112C7.06202 15.743 4.38298 17.0331 6.0147 18.6474C6.81178 19.436 7.69952 20 8.81562 20H15.1844C16.3005 20 17.1882 19.436 17.9853 18.6474C19.617 17.0331 16.938 15.743 15.9162 15.1112C13.5201 13.6296 10.4798 13.6296 8.0838 15.1112Z"
        stroke="#1D5EA0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z"
        stroke="#1D5EA0"
        strokeWidth="1.5"
      />
    </>
  ),
  BriefCase01: (
    <>
      <path
        d="M10.484 13.3333C10.484 13.0233 10.484 12.8683 10.5163 12.7412C10.6038 12.3961 10.8592 12.1265 11.1862 12.0341C11.3066 12 11.4534 12 11.7471 12H13.0103C13.304 12 13.4509 12 13.5712 12.0341C13.8981 12.1265 14.1536 12.3961 14.2411 12.7412C14.2734 12.8683 14.2734 13.0233 14.2734 13.3333V14C14.2734 15.1045 13.4252 16 12.3787 16C11.3322 16 10.484 15.1045 10.484 14V13.3333Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1787 13.5H15.2991C16.5157 13.5 17.124 13.5 17.6419 13.3843C19.141 13.049 20.3641 12.0207 20.8992 10.6455C21.0841 10.1704 21.1595 9.59552 21.3105 8.44569C21.3672 8.01405 21.3955 7.79823 21.3683 7.62169C21.2889 7.10753 20.8986 6.68637 20.3727 6.54764C20.1921 6.5 19.9638 6.5 19.5071 6.5H5.25034C4.7936 6.5 4.56523 6.5 4.38467 6.54764C3.85885 6.68637 3.46848 7.10753 3.38915 7.62169C3.36192 7.79823 3.39024 8.01405 3.44689 8.44569C3.5978 9.59552 3.67325 10.1704 3.85815 10.6455C4.39333 12.0207 5.61637 13.049 7.11546 13.3843C7.63338 13.5 8.24171 13.5 9.45836 13.5H10.5787"
        stroke="currentColor"
        strokeWidth="1.125"
      />
      <path
        d="M4.32606 11.5V13.5C4.32606 17.2712 4.32606 19.1569 5.37432 20.3284C6.42256 21.5 8.1097 21.5 11.484 21.5H13.2734C16.6478 21.5 18.3349 21.5 19.383 20.3284C20.4313 19.1569 20.4313 17.2712 20.4313 13.5V11.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6945 6.5L15.6212 6.14679C15.2565 4.38673 15.0741 3.50671 14.64 3.00335C14.2059 2.5 13.6291 2.5 12.4756 2.5H12.2818C11.1283 2.5 10.5516 2.5 10.1174 3.00335C9.68323 3.50671 9.50085 4.38673 9.13612 6.14679L9.06291 6.5"
        stroke="currentColor"
        strokeWidth="1.125"
      />
    </>
  ),
  MapPin: (
    <>
      <path
        d="M7 9.00195C4.82497 9.01507 3.64706 9.11956 2.87868 9.95197C2 10.9039 2 12.4359 2 15.5C2 18.5642 2 20.0962 2.87868 21.0481C3.75736 22 5.17157 22 8 22H16C18.8284 22 20.2426 22 21.1213 21.0481C22 20.0962 22 18.5642 22 15.5C22 12.4359 22 10.9039 21.1213 9.95197C20.3529 9.11956 19.175 9.01507 17 9.00195"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12L10.5 14.625M10.5 14.625L13.8 16.55M10.5 14.625L6 17.6M18 19L13.8 16.55M13.8 16.55L18 13.75"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7C13.3807 7 14.5 5.88071 14.5 4.5C14.5 3.11929 13.3807 2 12 2C10.6193 2 9.5 3.11929 9.5 4.5C9.5 5.88071 10.6193 7 12 7ZM12 7V11"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
    </>
  ),
  Maping: (
    <>
      <path
        d="M5.48209 4.19584L4.31885 4.90813C3.38266 5.48137 2.91457 5.768 2.65722 6.24483C2.39987 6.72165 2.39987 7.30233 2.39987 8.46368V16.6283C2.39987 18.1543 2.39987 18.9172 2.72413 19.3419C2.93989 19.6244 3.24224 19.8143 3.57651 19.8773C4.07886 19.9719 4.69391 19.5953 5.92396 18.8421C6.75925 18.3307 7.56315 17.7995 8.56239 17.9435C9.01693 18.0091 9.45049 18.2367 10.3176 18.6917L13.9307 20.588C14.7123 20.9983 14.7195 21 15.5886 21H17.5578C19.3441 21 20.2373 21 20.7923 20.4013C21.3472 19.8027 21.3472 18.8389 21.3472 16.9117V10.1715C21.3472 8.24423 21.3472 7.2806 20.7923 6.68188C20.2373 6.08316 19.3441 6.08316 17.5578 6.08316H15.5886C14.7195 6.08316 14.7123 6.08139 13.9307 5.6712L10.7745 4.01463C9.45667 3.32297 8.79776 2.97715 8.09582 3.00117C7.39386 3.02521 6.75661 3.41543 5.48209 4.19584Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7157 6.5V20.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="0.75 2.25"
      />
      <path
        d="M8.08408 3.5V17.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="0.75 2.25"
      />
    </>
  ),
  BatteriesEnergy: (
    <>
      <path d="M12.095 2L9.72657 6H13.516L11.1476 10" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16.3581 6C17.2513 6 17.6979 6 17.9754 6.29289C18.2529 6.58579 18.2529 7.05719 18.2529 8V10.5M6.88446 6C5.99127 6 5.54468 6 5.26719 6.29289C4.98973 6.58579 4.98973 7.05719 4.98973 8V10.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2003 13H17.3055C16.4123 13 15.9657 13 15.6883 13.2929C15.4108 13.5859 15.4108 14.0572 15.4108 15V20C15.4108 20.9428 15.4108 21.4141 15.6883 21.7071C15.9657 22 16.4123 22 17.3055 22H19.2003C20.0934 22 20.54 22 20.8175 21.7071C21.095 21.4141 21.095 20.9428 21.095 20V15C21.095 14.0572 21.095 13.5859 20.8175 13.2929C20.54 13 20.0934 13 19.2003 13Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15.4108 19H21.095" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.4108 16H21.095" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5.93709 13H4.04236C3.14917 13 2.70258 13 2.42509 13.2929C2.14762 13.5859 2.14762 14.0572 2.14762 15V20C2.14762 20.9428 2.14762 21.4141 2.42509 21.7071C2.70258 22 3.14917 22 4.04236 22H5.93709C6.83027 22 7.27686 22 7.55435 21.7071C7.83183 21.4141 7.83183 20.9428 7.83183 20V15C7.83183 14.0572 7.83183 13.5859 7.55435 13.2929C7.27686 13 6.83027 13 5.93709 13Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.14762 19H7.83183" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.14762 16H7.83183" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Search: (
    <>
      <path d="M17.5 17.5L22 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M20 11C20 6.02944 15.9705 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9705 6.02944 20 11 20C15.9705 20 20 15.9705 20 11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </>
  ),
  Add01: (
    <>
      <path d="M12 1.71428V22.2857" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.71429 12H22.2857" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  ArrowUp: (
    <>
      <path
        d="M23.6803 16.7691L12.7718 5.65917C12.6705 5.55588 12.5502 5.47393 12.4177 5.41801C12.2853 5.36211 12.1434 5.33333 12 5.33333C11.8566 5.33333 11.7147 5.36211 11.5823 5.41801C11.4498 5.47393 11.3295 5.55588 11.2282 5.65917L0.319681 16.7691C0.114993 16.9775 0 17.2603 0 17.5551C0 17.8499 0.114993 18.1327 0.319681 18.3411C0.524369 18.5496 0.801987 18.6667 1.09146 18.6667C1.38093 18.6667 1.65855 18.5496 1.86324 18.3411L12 8.01585L22.1368 18.3411C22.2381 18.4443 22.3584 18.5261 22.4908 18.582C22.6233 18.6379 22.7652 18.6667 22.9085 18.6667C23.0519 18.6667 23.1937 18.6379 23.3263 18.582C23.4587 18.5261 23.5789 18.4443 23.6803 18.3411C23.7817 18.2379 23.862 18.1153 23.9169 17.9804C23.9717 17.8456 24 17.7011 24 17.5551C24 17.4091 23.9717 17.2645 23.9169 17.1297C23.862 16.9948 23.7817 16.8723 23.6803 16.7691Z"
        fill="currentColor"
      />
    </>
  ),
  ChartBubble: (
    <>
      <path
        d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="11.5" cy="15.5" r="2.5" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="17.5" cy="7.5" r="3.5" stroke="currentColor" strokeWidth="1.5" />
    </>
  ),
  FileDownload: (
    <>
      <path
        d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9V2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 13V14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Download4: (
    <>
      <path
        d="M12 14.5L12 4.5M12 14.5C11.2998 14.5 9.99153 12.5057 9.5 12M12 14.5C12.7002 14.5 14.0085 12.5057 14.5 12"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Passport2: (
    <>
      <path
        d="M12.9503 22C15.595 22 16.9173 22 17.8667 21.2437C18.8161 20.4874 19.1189 19.1927 19.7247 16.6033L21.642 8.40696C21.9773 6.97362 22.1449 6.25695 21.8405 5.7379C21.2878 4.79528 19.8789 5 18.9593 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 9C2 5.70017 2 4.05025 3.02513 3.02513C4.05025 2 5.70017 2 9 2H12C15.2998 2 16.9497 2 17.9749 3.02513C19 4.05025 19 5.70017 19 9V15C19 18.2998 19 19.9497 17.9749 20.9749C16.9497 22 15.2998 22 12 22H9C5.70017 22 4.05025 22 3.02513 20.9749C2 19.9497 2 18.2998 2 15V9Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M10.5 6C12.7091 6 14.5 7.79086 14.5 10C14.5 12.2091 12.7091 14 10.5 14M10.5 6C8.29086 6 6.5 7.79086 6.5 10C6.5 12.2091 8.29086 14 10.5 14M10.5 6C9.67157 6 9 7.79086 9 10C9 12.2091 9.67157 14 10.5 14M10.5 6C11.3284 6 12 7.79086 12 10C12 12.2091 11.3284 14 10.5 14"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M7 17L14 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </>
  ),
  ArrowReloadHorizontal: (
    <>
      <path
        d="M20.209 5.80915H9.73289C6.19643 5.80915 3.54241 8.36632 3.54241 11.9997"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.01785 18.1905H14.4941C18.0305 18.1905 20.6846 15.6334 20.6846 12"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3035 3.42857C18.3035 3.42857 20.6846 5.18211 20.6846 5.80954C20.6846 6.43697 18.3035 8.19048 18.3035 8.19048"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.92335 15.8091C5.92335 15.8091 3.54242 17.5626 3.54241 18.1901C3.5424 18.8175 5.92336 20.5711 5.92336 20.5711"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Chatting: (
    <>
      <path
        d="M20 9C19.2048 5.01455 15.5128 2 11.0793 2C6.06549 2 2 5.85521 2 10.61C2 12.8946 2.93819 14.9704 4.46855 16.5108C4.80549 16.85 5.03045 17.3134 4.93966 17.7903C4.78982 18.5701 4.45026 19.2975 3.95305 19.9037C5.26123 20.1449 6.62147 19.9277 7.78801 19.3127C8.20039 19.0954 8.40657 18.9867 8.55207 18.9646C8.65392 18.9492 8.78659 18.9636 9 19.0002"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 16.2617C11 19.1674 13.4628 21.5234 16.5 21.5234C16.8571 21.5238 17.2132 21.4908 17.564 21.425C17.8165 21.3775 17.9428 21.3538 18.0309 21.3673C18.119 21.3807 18.244 21.4472 18.4938 21.58C19.2004 21.9558 20.0244 22.0885 20.8169 21.9411C20.5157 21.5707 20.31 21.1262 20.2192 20.6496C20.1642 20.3582 20.3005 20.075 20.5046 19.8677C21.4317 18.9263 22 17.6578 22 16.2617C22 13.356 19.5372 11 16.5 11C13.4628 11 11 13.356 11 16.2617Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </>
  ),
  UserRemove: (
    <>
      <path
        d="M13 22H6.59087C5.04549 22 3.81631 21.248 2.71266 20.1966C0.453366 18.0441 4.1628 16.324 5.57757 15.4816C7.97679 14.053 10.8425 13.6575 13.5 14.2952"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path d="M16 22L19 19M19 19L22 16M19 19L16 16M19 19L22 22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </>
  ),
  Call02: (
    <>
      <path
        d="M9.57929 6.01165L9.19581 5.14881C8.94506 4.58465 8.81969 4.30255 8.63219 4.08667C8.39721 3.81614 8.09093 3.61709 7.74826 3.51224C7.47485 3.42857 7.16615 3.42857 6.54877 3.42857C5.64562 3.42857 5.19406 3.42857 4.81498 3.60218C4.36845 3.80669 3.96518 4.25074 3.8045 4.71486C3.6681 5.10885 3.70718 5.51375 3.78531 6.32352C4.61705 14.9431 9.34269 19.6687 17.9622 20.5003C18.772 20.5785 19.1769 20.6176 19.5709 20.4813C20.035 20.3206 20.479 19.9173 20.6835 19.4707C20.8571 19.0917 20.8571 18.6401 20.8571 17.7369C20.8571 17.1195 20.8571 16.8109 20.7735 16.5374C20.6686 16.1947 20.4696 15.8885 20.199 15.6535C19.9832 15.4659 19.7011 15.3407 19.1369 15.0899L18.2741 14.7064C17.6631 14.4349 17.3576 14.2991 17.0472 14.2696C16.7501 14.2414 16.4505 14.2831 16.1725 14.3913C15.8818 14.5045 15.6251 14.7185 15.1114 15.1465C14.6001 15.5726 14.3446 15.7856 14.0321 15.8997C13.7552 16.0008 13.3891 16.0384 13.0975 15.9953C12.7685 15.9469 12.5166 15.8123 12.0126 15.543C10.445 14.7053 9.5805 13.8408 8.74273 12.273C8.47346 11.7693 8.33883 11.5173 8.29035 11.1883C8.24737 10.8966 8.28483 10.5305 8.386 10.2536C8.50011 9.94122 8.71315 9.68558 9.13922 9.17429C9.56726 8.66065 9.78127 8.40383 9.89442 8.11325C10.0027 7.83518 10.0444 7.53562 10.0161 7.23855C9.98661 6.92811 9.85083 6.62263 9.57929 6.01165Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </>
  ),
  GoogleDoc: (
    <>
      <path
        d="M15 2.95201V4.38058C15 5.72745 15 6.40088 15.4393 6.8193C15.8786 7.23773 16.5858 7.23773 18 7.23773H19.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.9999 15.8099V8.19085C3.9999 5.49711 3.9999 4.15024 4.87859 3.31341C5.75726 2.47656 7.17148 2.47656 9.9999 2.47656H14.1715C14.5802 2.47656 14.7846 2.47656 14.9684 2.54906C15.1522 2.62155 15.2968 2.75919 15.5857 3.03446L19.4141 6.68057C19.7032 6.95584 19.8478 7.09347 19.9238 7.26849C19.9999 7.44352 19.9999 7.63816 19.9999 8.02745V15.8099C19.9999 18.5037 19.9999 19.8505 19.1212 20.6873C18.2425 21.5242 16.8283 21.5242 13.9999 21.5242H9.9999C7.17148 21.5242 5.75726 21.5242 4.87859 20.6873C3.9999 19.8505 3.9999 18.5037 3.9999 15.8099Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0001 11.048H16.0001M8.0001 13.9051H16.0001M8.0001 16.7623H12.1709"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Building05: (
    <>
      <path d="M2.19057 21.5234H21.2382" stroke="#2A3845" strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M17.4287 9.14286H13.6191C11.2553 9.14286 10.762 9.63619 10.762 12V21.5238H20.2858V12C20.2858 9.63619 19.7925 9.14286 17.4287 9.14286Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M14.5714 21.5242H3.14286V5.3337C3.14286 2.9699 3.63619 2.47656 6 2.47656H11.7143C14.0781 2.47656 14.5714 2.9699 14.5714 5.3337V9.14323"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path d="M3.14286 6.28571H6M3.14286 10.0952H6M3.14286 13.9048H6" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M14.5714 12.952H16.4762M14.5714 15.8091H16.4762" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M15.5238 21.5234V18.6663" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  Mail01: (
    <>
      <path
        d="M2.762 6.28571L9.34583 10.0162C11.773 11.3914 12.7985 11.3914 15.2258 10.0162L21.8096 6.28571"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M2.77702 13.4057C2.83927 16.3254 2.87041 17.785 3.94767 18.8665C5.02493 19.9478 6.52422 19.9854 9.52279 20.0608C11.3709 20.1072 13.2008 20.1072 15.0488 20.0608C18.0474 19.9854 19.5466 19.9478 20.624 18.8665C21.7013 17.785 21.7323 16.3254 21.7945 13.4057C21.8146 12.467 21.8146 11.5338 21.7945 10.595C21.7323 7.67547 21.7013 6.21569 20.624 5.13433C19.5466 4.05297 18.0474 4.0153 15.0488 3.93997C13.2008 3.89352 11.3709 3.89352 9.52278 3.93995C6.52422 4.01529 5.02493 4.05295 3.94767 5.13432C2.8704 6.21569 2.83927 7.67546 2.77701 10.595C2.75698 11.5338 2.75699 12.467 2.77702 13.4057Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </>
  ),
  MailSend02: (
    <>
      <path
        d="M22 12.5001C22 12.0087 21.9947 11.0172 21.9841 10.5244C21.9189 7.45887 21.8863 5.92609 20.7551 4.79067C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09881 3.53656C5.95033 3.61567 4.37608 3.65521 3.24495 4.79065C2.11383 5.92608 2.08113 7.45885 2.01576 10.5244C1.99473 11.5101 1.99475 12.4899 2.01577 13.4756C2.08115 16.5412 2.11383 18.0739 3.24496 19.2095C4.37608 20.3448 5.95033 20.3843 9.09883 20.4635C9.90159 20.4836 10.7011 20.4955 11.5 20.4989"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8.5L9.94203 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 17.5H14M22 17.5C22 16.7997 20.0057 15.4915 19.5 15M22 17.5C22 18.2003 20.0057 19.5085 19.5 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Group: (
    <>
      <path d="M17.8002 5.1994L19.0013 6.34226L21.0002 4.4375" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M20.582 9.29713C20.855 10.1123 20.996 10.9624 21 11.8181C21 16.552 16.9705 20.3895 12 20.3895C7.02943 20.3895 3 16.552 3 11.8181C3 7.08421 7.02943 3.24665 12 3.24665C12.8984 3.25046 13.791 3.3847 14.647 3.64474"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6803 7.26435C11.8041 7.09199 12.0313 7.01653 12.2407 7.07822C12.4501 7.13991 12.593 7.32436 12.5929 7.53316V10.6231H15.4993C15.6848 10.6231 15.855 10.7209 15.9415 10.8771C16.0282 11.0333 16.0168 11.2223 15.912 11.3681L12.3199 16.3715C12.1962 16.5439 11.969 16.6194 11.7596 16.5577C11.5501 16.496 11.4073 16.3115 11.4074 16.1027V13.0128H8.50094C8.31548 13.0128 8.14528 12.9151 8.05874 12.7589C7.97221 12.6026 7.98358 12.4136 8.08828 12.2678L11.6803 7.26435Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  CheckMarkSquare03: (
    <>
      <path
        d="M21.4477 8.2C21.5 9.25014 21.5 10.4994 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C13.0719 2.5 14.0156 2.5 14.85 2.51908"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8 11.5C8 11.5 9.5 11.5 11.5 15C11.5 15 16.5588 5.83333 21.5 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  CancelSquare: (
    <>
      <path d="M15 9L9 14.9996M15 15L9 9.00039" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </>
  ),
  File02: (
    <>
      <path d="M8 17H16" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 13H12" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13 2.5V3C13 5.82843 13 7.24264 13.8787 8.12132C14.7574 9 16.1716 9 19 9H19.5M20 10.6569V14C20 17.7712 20 19.6569 18.8284 20.8284C17.6569 22 15.7712 22 12 22C8.22876 22 6.34315 22 5.17157 20.8284C4 19.6569 4 17.7712 4 14V9.45584C4 6.21082 4 4.58831 4.88607 3.48933C5.06508 3.26731 5.26731 3.06508 5.48933 2.88607C6.58831 2 8.21082 2 11.4558 2C12.1614 2 12.5141 2 12.8372 2.11401C12.9044 2.13772 12.9702 2.165 13.0345 2.19575C13.3436 2.34355 13.593 2.593 14.0919 3.09188L18.8284 7.82843C19.4065 8.40649 19.6955 8.69552 19.8478 9.06306C20 9.4306 20 9.83935 20 10.6569Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Tick01: (
    <>
      <path
        d="M5 14.5C5 14.5 6.5 14.5 8.5 18C8.5 18 14.0588 8.83333 19 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Factory02: (
    <>
      <path
        d="M10.154 21H21C21.471 21 21.707 21 21.854 20.854C22 20.707 22 20.47 22 20V7L17.64 10.633C16.93 11.225 16.576 11.52 16.288 11.385C16 11.25 16 10.79 16 9.865V7L11.552 10.235C11.03 10.615 10.77 10.804 10.468 10.902C10.167 11 9.84401 11 9.20001 11H9.00001M4.00001 6H8.00001M12 15H14M17 15H19M2.05701 19.874L4.00501 4.701C4.18301 3.314 4.53501 3 5.95601 3C7.37701 3 7.73001 3.314 7.90801 4.7L10 21H3.06001C2.52501 21 2.25801 21 2.10701 20.83C1.95601 20.661 1.99001 20.399 2.05701 19.874Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  DocumentAttachment: (
    <>
      <path
        d="M21 11V10C21 6.22876 21 4.34315 19.7595 3.17157C18.519 2 16.5225 2 12.5294 2L11.4706 2C7.47752 2 5.48098 2 4.24049 3.17157C3 4.34315 3 6.22876 3 10L3 14C3 17.7712 3 19.6569 4.24049 20.8284C5.48098 22 7.47751 22 11.4706 22H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M8 7L16 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 12L13 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M21 20.6471L21 17C21 15.5706 19.6569 14 18 14C16.3431 14 15 15.5706 15 17L15 20.5C15 21.2797 15.7326 22 16.6364 22C17.5401 22 18.2727 21.2797 18.2727 20.5L18.2727 17.7647"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
  Attachment2: (
    <>
      <path
        d="M8 8.00049V6.00049C8 3.79135 9.79086 2.00049 12 2.00049C14.2091 2.00049 16 3.79135 16 6.00049V18.0005C16 20.2096 14.2091 22.0005 12 22.0005C9.79086 22.0005 8 20.2096 8 18.0005V13.5005C8 12.1198 9.11929 11.0005 10.5 11.0005C11.8807 11.0005 13 12.1198 13 13.5005V16.0005"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  CheckmarkCircle03: (
    <>
      <g clipPath="ur#clip0_1_2)">
        <path
          d="M16.898 3.33782C15.4571 2.48697 13.7843 2 12 2C6.58986 2 2.20408 6.47715 2.20408 12C2.20408 17.5229 6.58986 22 12 22C17.4101 22 21.7959 17.5229 21.7959 12C21.7959 11.3151 21.7285 10.6462 21.6 10"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M8.08163 12.5C8.08163 12.5 9.55102 12.5 11.5102 16C11.5102 16 16.9556 6.83335 21.7959 5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  DocumentValidation: (
    <>
      <path
        d="M14.9805 7.01562C14.9805 7.01562 15.4805 7.51562 15.9805 8.51562C15.9805 8.51562 17.5687 6.01562 18.9805 5.51562"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99485 2.0214C7.49638 1.91562 5.56612 2.20344 5.56612 2.20344C4.34727 2.29059 2.01146 2.97391 2.01148 6.9646C2.0115 10.9214 1.98564 15.7994 2.01148 17.744C2.01148 18.9321 2.7471 21.7034 5.29326 21.8519C8.3881 22.0325 13.9627 22.0709 16.5204 21.8519C17.2051 21.8133 19.4846 21.2758 19.7731 18.7957C20.072 16.2264 20.0125 14.4408 20.0125 14.0158"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9998 7.01562C21.9998 9.77705 19.7591 12.0157 16.995 12.0157C14.2309 12.0157 11.9902 9.77705 11.9902 7.01562C11.9902 4.2542 14.2309 2.01562 16.995 2.01562C19.7591 2.01562 21.9998 4.2542 21.9998 7.01562Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path d="M6.98047 13.0156H10.9804" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
      <path d="M6.98047 17.0156H14.9804" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
    </>
  ),
  Upload04: (
    <>
      <path
        d="M12 4.5L12 14.5M12 4.5C11.2998 4.5 9.99153 6.4943 9.5 7M12 4.5C12.7002 4.5 14.0085 6.4943 14.5 7"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 16.5C20 18.982 19.482 19.5 17 19.5H7C4.518 19.5 4 18.982 4 16.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  Comment01: (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 13.5H16M8 8.5H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </>
  )
}
